/* eslint-disable require-jsdoc */

'use strict';

var appResources = window.appResources;
var preferences = appResources.preferences || {};
var resources = appResources.resources || {};

/**
 * Get the recaptcha token, Handle reCaptcha behavior, calling v3
 * @returns {Promise} - A promise that resolves to the recaptcha response
 */
function getRecaptchaToken() {
    return new Promise(function (resolve, reject) {
        if (preferences.googleRecaptchaV3Enabled) {
            // eslint-disable-next-line no-undef
            grecaptcha.ready(function () {
                // eslint-disable-next-line no-undef
                grecaptcha.execute(preferences.googleRecaptchaV3SiteKey, {
                    action: 'submit'
                }).then(function (token) {
                    resolve({ success: true, recaptchaToken: token });
                }).catch(function () {
                    var error = new Error(resources.googleRecaptchaFailErrorMsg);
                    error.success = false;
                    error.errorMsg = resources.googleRecaptchaFailErrorMsg;
                    reject(error);
                });
            });
        } else {
            // If reCAPTCHA is disabled, resolve immediately
            resolve({ success: true });
        }
    });
}

module.exports = {
    getRecaptchaToken: getRecaptchaToken
};
